<script lang="ts">
    import TagSearch from "./Components/TagSearch.svelte";
    console.log("hello wordl");
</script>

<article class="panel is-primary">
    <TagSearch />
</article>
